import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const DARK = {
  bg:        '#131416',
  surface:   '#1c1d20',
  surfaceHi: '#242628',
  border:    '#2e3033',
  borderHi:  '#3e4046',
  text:      '#e8e9ea',
  textMuted: '#6b6e75',
  textDim:   '#3e4046',
  yes:       '#16c784',
  yesDim:    'rgba(22,199,132,0.12)',
  no:        '#ea3943',
  noDim:     'rgba(234,57,67,0.12)',
  accent:    '#3772ff',
  accentDim: 'rgba(55,114,255,0.12)',
  gold:      '#f3a94a',
};

export const LIGHT = {
  bg:        '#f5f6f8',
  surface:   '#ffffff',
  surfaceHi: '#f0f1f3',
  border:    '#e2e4e8',
  borderHi:  '#c8cad0',
  text:      '#1a1b1e',
  textMuted: '#5a5d66',
  textDim:   '#b0b3bb',
  yes:       '#16c784',
  yesDim:    'rgba(22,199,132,0.12)',
  no:        '#ea3943',
  noDim:     'rgba(234,57,67,0.12)',
  accent:    '#3772ff',
  accentDim: 'rgba(55,114,255,0.12)',
  gold:      '#f3a94a',
};

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    try {
      return localStorage.getItem('theme') === 'dark';
    } catch {
      return false;
    }
  });

  const toggle = () => {
    setDark(d => {
      const next = !d;
      localStorage.setItem('theme', next ? 'dark' : 'light');
      return next;
    });
  };

  useEffect(() => {
    try {
      const theme = dark ? 'dark' : 'light';
      localStorage.setItem('theme', theme);
      document.body.classList.toggle('light', !dark);
    } catch {}
  }, [dark]);

  const T = dark ? DARK : LIGHT;
  return (
    <ThemeContext.Provider value={{ dark, toggle, T }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);